import { supabase } from '@/lib/supabase/client'

export const sendTestNewsletter = async () => {
  const { data, error } = await supabase.functions.invoke(
    'manual-newsletter-sender',
  )

  if (error) {
    console.error('Error sending test newsletter:', error)
    // The error from invoke might contain the response from the edge function.
    // We can try to extract a more specific message.
    if (error.context && typeof error.context.json === 'function') {
      try {
        const { error: functionError } = await error.context.json()
        if (functionError) {
          throw new Error(functionError)
        }
      } catch (e) {
        // Ignore parsing error and throw original
      }
    }
    throw error
  }

  return data
}
